import { createMemo, JSX, Show } from 'solid-js';
import { t } from '@trimble/i18n';
import { useDropdown } from '@trimble/solidjs-utils';
import ProjectSelection from './ProjectSelection';

interface ProjectMenuProps {
  projectExplorerUrl?: string;
}

export const ProjectMenu = (props: ProjectMenuProps): JSX.Element => {
  const { isOpen, toggle, ref } = useDropdown();

  const projectExplorerUrl = createMemo<string>(() => {
    return props.projectExplorerUrl ?? '#';
  });

  return (
    <div class="flex items-center gap-2" data-testid="project-menu">
      <span class="text-base leading-none" data-testid="project-selector">
        <ProjectSelection />
      </span>
      <div class="relative" ref={ref}>
        <div
          class={`w-10 h-10 flex items-center justify-center rounded-sm cursor-pointer transition-colors duration-300 text-base-content ${
            isOpen() ? 'bg-base-200' : 'hover:bg-base-200'
          }`}
          onClick={toggle}
          data-testid="project-folder-button"
        >
          <i class="icon-font tc-icon-folder" />
        </div>
        <Show when={isOpen()}>
          <div
            data-testid="header-folder-dropdown"
            class="absolute left-0 w-56 bg-base-page text-base-content rounded-sm py-1 py-3"
            // eslint-disable-next-line @typescript-eslint/naming-convention
            style={{ 'box-shadow': '0 0 .375rem #aeaeb6' }}
          >
            <a
              href={projectExplorerUrl()}
              class="block w-full text-left px-4 py-2 text-sm text-base-content hover:bg-base-200 no-underline"
              data-testid="project-open-link"
            >
              {t('general.header.open')}
            </a>
            <a
              href={projectExplorerUrl()}
              target="_blank"
              class="block w-full text-left px-4 py-2 text-sm text-base-content hover:bg-base-200 no-underline"
              data-testid="project-open-new-tab-link"
            >
              {t('general.header.openInNewTab')}
            </a>
            <a
              href={projectExplorerUrl()}
              target="_blank"
              class="block w-full text-left px-4 py-2 text-sm text-base-content hover:bg-base-200 no-underline"
              data-testid="project-open-new-window-link"
              onClick={(e) => {
                e.preventDefault();
                window.open(projectExplorerUrl(), '_blank', 'popup');
              }}
            >
              {t('general.header.openInNewWindow')}
            </a>
          </div>
        </Show>
      </div>
    </div>
  );
};
